import { render } from "./App.vue?vue&type=template&id=190056cc"
const script = {}

import "./App.vue?vue&type=style&index=0&id=190056cc&lang=css"

import exportComponent from "/Users/zllword/zongxueguan/project/verite-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__